import CustomTextField from "../../common/CustomTextField";
import { withStyles } from "@material-ui/core/styles";
import { Button, CircularProgress } from "@material-ui/core";
import { MAX_LENGTH_CONSTRAINTS } from "../../common/constants";
import {ONLY_NUMBER_REGEX} from "../../../constRegex";

const styles = (theme) => ({
  inputContainer: {
    display: "inline-flex",
    marginTop: 16,
    width: "100%",
    justifyContent: "space-between",
  },
  inputWidth: { flexBasis: "64%" },
  actionButton: {
    height: 43,
    marginTop: 16,
    minWidth: "30%",
    marginLeft: 8,
    "&:disabled": {
      color: theme.TextColor,
    },
  },
  circularProgress: {
    color: theme.white,
  },
});
const Form = ({
  handleChange,
  handleSubmit,
  proData,
  classes,
  isGetProDetailsInProgress,
}) => {
  return (
    <div className={classes.inputContainer}>
      <CustomTextField
        id="proNumberInput"
        label="Pro number"
        handleChange={handleChange("inputProNumber")}
        value={proData.inputValue}
        className={classes.inputWidth}
        error={proData.error}
        autoFocus
        inputProps={{
          pattern: ONLY_NUMBER_REGEX,
          maxLength: MAX_LENGTH_CONSTRAINTS.PICKUP_PRO_FORM.PRO_NUMBER,
        }}
        helperText={"Enter a pro number without check digit"}
      />
      <Button
        autoFocus
        color="primary"
        variant="contained"
        className={classes.actionButton}
        onClick={!isGetProDetailsInProgress ? handleSubmit : null}
        disabled={!proData.inputValue}
      >
        {isGetProDetailsInProgress ? (
          <CircularProgress
            size={16}
            classes={{ root: classes.circularProgress }}
          />
        ) : (
          "Show Details"
        )}
      </Button>
    </div>
  );
};

export default withStyles(styles)(Form);
